import { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import styles from './segmentSummary.module.scss'
import Paper from '../Paper';
import { useDispatch, useSelector } from 'react-redux';
import { getDateTimeFromMillis, writeSummary, getDataFromTree } from '../../utils/utils';
import { getAttributes } from "../../containers/CreateCampaigns/createCampaignReducer";
import { createCampaignQuery } from '../../containers/CreateCampaigns/constants';

const SegmentSummary = ({ onEdit, onSubmit, onPause, onResume }) => {
  const { summary } = useSelector(store => store.segmentSummary)
  const createdTime = getDateTimeFromMillis(Number(summary.createdTime))
  const customerSegmentData = useSelector(state => state.createCampaign.attributeData)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAttributes({ entityType: createCampaignQuery.customer }))
  },[])

  return (
    <Grid container className={styles.campaginSummaryContainer}>
      <Paper p="0px 26px 5px">
        <Grid container className={styles.summaryContainer} justifyContent="space-between" alignItems="center">
          <Grid item xs={12} container justifyContent="space-between">
            <Grid item xs={4}>
              <Typography className={styles.heading}>Segment ID:&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.text}>{summary.segmentId}</span></Typography>
            </Grid>
            <Grid item xs={4} textAlign="right">
              <Typography className={styles.heading}>Segment Status:&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.text}>{summary.status}</span></Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Paper p="0px 26px 5px">
        <Grid container className={styles.summaryContainer}>
          <Grid item container justifyContent="space-between">
            <Grid item xs={12} paddingBottom="10px" marginBottom="10px" borderBottom="0.5px solid #9E9E9E">
              <Typography className={styles.heading}>Segment Name&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.text}>{summary.segmentName || summary.name}</span></Typography>
            </Grid>
            <Grid item xs={12} paddingBottom="10px">
              <Typography className={styles.heading}>Segment Attributes</Typography>
            </Grid>
            <Grid item xs={12}>
              {summary.summary}
            </Grid>
            <Grid item xs={3} />
          </Grid>
        </Grid>
      </Paper>
      <Paper p="0px 26px 5px">
        <Grid container className={styles.summaryContainer}>
          <Grid item container className={styles.summaryContainerRow} justifyContent="space-between" marginTop="15px">
            <Grid item xs={12} paddingBottom="10px">
              <Typography className={styles.heading}>Created by:&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.text}>{summary.createdBy}</span></Typography>
            </Grid>
            <Grid item xs={12} paddingBottom="10px">
              <Typography className={styles.heading}>Created time:&nbsp;&nbsp;&nbsp;&nbsp;<span className={styles.text}>{createdTime.date} {createdTime.time}</span></Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Grid >
  );
}

export default SegmentSummary
